import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../../components/Header';
import CrudRouter from '../../../components/Systema/Crud/CrudRouter';
import CrudBar from '../../../components/Systema/Crud/CrudBar';
import NewTree from '../../../components/NewTree/NewTree';
import config from '../../../config';
import EstruturaOrganizacionalForm from './form';
import service from './service';

const columns = [
  { header: '' },
  { header: 'Codigo', property: 'codigo' },
  { header: 'Nome', property: 'nome' },
];

export default function EstruturaOrganizacionalCrudNovo() {
  const [selected, setSelected] = useState(null);

  return (
    <Container fluid>
      <Header>Estrutura Organizacional</Header>
      <CrudRouter form={EstruturaOrganizacionalForm} service={service}>
        <CrudBar selected={selected} />
        <NewTree
          path={`${config.api_path}/v1/estrutura-organizacional`}
          columns={columns}
          onSelect={setSelected}
          setTreeAction={() => { }}
          enableTotals={false}
        />
      </CrudRouter>
    </Container>
  );
}
